function isTorqueUnit(unitProfile) {
    if (unitProfile === undefined) return false;

    if (unitProfile && typeof unitProfile === 'string') {
        return unitProfile.indexOf('(') >= 0;
    }

    return unitProfile !== undefined && unitProfile.name.indexOf('(') >= 0;
}

function isSI(unitProfile) {
    if (unitProfile && typeof unitProfile === 'string') {
        return unitProfile.name.toLowerCase().indexOf('si') >= 0;
    }

    return unitProfile !== undefined && unitProfile.name.toLowerCase().indexOf('si') >= 0;
}

function isImperial(unitProfile) {
    if (unitProfile && typeof unitProfile === 'string') {
        return unitProfile.name.toLowerCase().indexOf('imperial') >= 0;
    }

    return unitProfile !== undefined && unitProfile.name.toLowerCase().indexOf('imperial') >= 0;
}

export { isTorqueUnit, isSI, isImperial };
